var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('groupPerson',{on:{"openGroupInfo":_vm.openGroupInfo}}),_c('groupInfo',{directives:[{name:"show",rawName:"v-show",value:(_vm.infoBoolean),expression:"infoBoolean"}],on:{"closeGroupInfo":_vm.closeGroupInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }